import { render, staticRenderFns } from "./ModalSendToCommittee.vue?vue&type=template&id=a3645802&scoped=true"
import script from "./ModalSendToCommittee.vue?vue&type=script&lang=js"
export * from "./ModalSendToCommittee.vue?vue&type=script&lang=js"
import style0 from "./ModalSendToCommittee.vue?vue&type=style&index=0&id=a3645802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3645802",
  null
  
)

export default component.exports